import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import axios from "./AxiosClient";
import "./sa-icons.css";

export class ErrorPage extends Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    axios.post("/ui/error", {
      stackTrace: error.stack,
      componentStack: info.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Dialog fullScreen open>
          <AppBar style={{ position: "relative" }}>
            <Toolbar>
              <Typography variant="h6">An error occurred</Typography>
            </Toolbar>
          </AppBar>
          <div
            style={{
              backgroundColor: "#eae0d7",
              backgroundImage: "url('./images/background.svg')",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Card>
              <CardContent style={{ textAlign: "center" }}>
                <div class="sa">
                  <div class="sa-error">
                    <div class="sa-error-x">
                      <div class="sa-error-left" />
                      <div class="sa-error-right" />
                    </div>
                    <div class="sa-error-placeholder" />
                    <div class="sa-error-fix" />
                  </div>
                </div>
                <Typography variant="h4" style={{ marginBottom: 20 }}>
                  An error occurred
                </Typography>
                <Typography gutterBottom>
                  Please refresh the page and try again.
                </Typography>
                <Typography style={{ marginBottom: 20 }}>
                  If this error keeps happening, please contact support.
                </Typography>
                <Button
                  size="large"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    window.location.reload();
                    return false;
                  }}
                  style={{ marginBottom: 10 }}
                >
                  Refresh
                </Button>
              </CardContent>
            </Card>
          </div>
        </Dialog>
      );
    }
    return this.props.children;
  }
}

export default ErrorPage;
